
import React, { useCallback, useState, useEffect } from "react";
import { getRequest } from "../../services/axiosBaseClient";
import styles from "./SwappingStation.module.scss";
import cn from "classnames";
import TableSwapHistory from "../common/TableSwapHistory";
import styled from "styled-components";

var offSetMainValue = 0;
var limitMainValue = 10;
var pageSizee = 10;
var pageNumber = 0;
var pagingString = "offset=" + pageNumber + "&limit=" + pageSizee;

var slotId;


const Styles = styled.div`
  table {
    th,
    td {
      border-bottom: 1px solid #f5f5ff;
      border-right: 0px solid black;
      padding: 8px;
      white-space: nowrap;
      text-align: start;

      :last-child {
        border-right: 0;
        text-align: left;
      }
    }
  }
`;

export default function SwappingSlot(props) {
  const [dataTable, setDataTable] = useState([]);
  const [limit, setLimit] = useState(10);
  const [offset, setOffset] = useState(0);
  const [slotDetailsCount, setSlotDetailsCount] = useState("");
  const [slotdate, setSlotDate] = useState(null);
  const [isRotating, setIsRotating] = useState(false);
  const paginationCountHanlde = (offset, limit) => {

    console.log(offset, limit, "offsett")
    setOffset(offset);
    offSetMainValue = offset;
    setLimit(limit);
    limitMainValue = limit;
    const pageoffset = offset;
    const pageLimit = limit;
    // console.log(test,"TESINGG")
    pagingString = "offset=" + pageoffset + "&limit=" + pageLimit;

    getBatterySwappingHistory()
  };

  const handleRefresh = () => {
    setIsRotating(true);
    // setShowProgressBar(true);

    setTimeout(() => {
      setIsRotating(false);
      // setShowProgressBar(false);
    }, 1000);
    getBatterySwappingHistory();
  };

  const handleDataLimitCallback = (offset, limit) => {
    setLimit(limit);
    limitMainValue = limit;
    setOffset(offset);
    offSetMainValue = offset;
    getBatterySwappingHistory();
  };


  const getBatterySwappingHistory = useCallback(async () => {

    console.log(pagingString, "pagingString")
    await getRequest(`swapStation/slotStatus?swapStationId=${slotId}&` + pagingString).then(
      (res) => {
        if (res && res?.data) {
          setSlotDate(res?.data?.updatedAt);
          setDataTable(res?.data?.slotStatusDtos);
          setSlotDetailsCount(res?.data?.count);
        }
      }
    );
  }, []);

  useEffect(() => {
    slotId = props?.id;
    pagingString = "offset=" + 0 + "&limit=" + 10;
    getBatterySwappingHistory();
  }, []);

  const columns = React.useMemo(() => [
    {
      Header: "Slot Serial",
      accessor: "name",
    },
    {
      Header: "Swap Station",
      accessor: "swapStationName",
    },
    {
      Header: "Battery",
      accessor: "batterySerial",
    },
    {
      Header: "SOC",
      accessor: "soc",
      Cell: (row) => { 
        return(
          <div >{row.row?.original?.soc? row.row?.original?.soc+"%" : <span >NA</span>}</div>
      ) },
    },
    {
      Header: "SOH",
      accessor: "soh",
      Cell: (row) => { 
        return(
          <div >{row.row?.original?.soh? row.row?.original?.soh+"%" : <span >NA</span>}</div>
      ) },
    },
    {
      Header: "Slot Status",
      accessor: "batteryStatus",
    },
  ]);

  return (
    <>
      <div
        styles={{ backgroundColor: "#FFFFFF" }}
        className={cn(styles.block25, styles.block25_layout)}
      >

        <Styles>
            <div style={{ padding: "10px 20px" }}> Last Updated on {slotdate ? new Date(slotdate).toLocaleString() : 'NA'}
              <img
                src={require("../../assets/sync_refresh.svg").default}
                className={cn(styles.dateRefresh_img, {
                  [styles.rotate]: isRotating,
                })}
                onClick={() => handleRefresh()}
              />
            </div>
          <TableSwapHistory
            columns={columns}
            data={dataTable}
            pagination={false}
            swapStationCount={slotDetailsCount}
            paginationCountHanlde={paginationCountHanlde}
            handleDataLimitCallback={handleDataLimitCallback}
          />
        </Styles>
      </div>
    </>
  );
}
